/**
 * Schema of Carga
 * @author Simpli CLI generator
 */
import {$, cep, phone, bool, cpfOrCnpj, datetime, InputType, Schema, cnpj} from 'simpli-web-sdk'
import * as Helpers from '@/helpers'
import CargaCsvSimplesSemCheckComponente from '@/model/resource/CargaCsvSimplesSemCheckComponente'
import RenderLabelValue from '@/components/render/RenderLabelValue.vue'

export default (model: CargaCsvSimplesSemCheckComponente): Schema => ({
    idCargaPk: {
        textContent: model.idCargaPk,
    },

    nroNotaFiscalAlt: {
        textContent: Helpers.formatScientificNumber(model.nroNotaFiscal),
    },

    dataCriacaoAlt: {
        textContent: Helpers.datetimeForCsv(model.dataCriacao),
    },

    dataInicioEntregaAlt: {
        textContent: model.dataInicioEntrega &&
        model.sistemaCriador &&
        model.sistemaCriador.idSistemaPk !== 3 ?
            Helpers.datetimeForCsv(model.dataInicioEntrega) : '' ,
    },

    dataCheckInAlt: {
        textContent: Helpers.datetimeForCsv(model.dataCheckIn),
    },

    dataFinalizacao: {
        textContent: Helpers.datetimeForCsv(model.dataFinalizacao),
    },

    dataPrevisaoAlt: {
        textContent: Helpers.datetimeForCsv(model.dataPrevisao),
    },

    dataBaixaSistemaAlt: {
        textContent: Helpers.datetimeForCsv(model.dataBaixaSistema),
    },

    slaStatusFinalizado: {
        content: model.slaFinalizado,
        textContent: model.slaFinalizado,
    },

    statusCarga: {
        textContent: model.dataFinalizacao ?
            (model.tipoOcorrencia ?
                (model.devolvida ? 'Devolvida' : 'Com ocorrência') : 'Sem ocorrência') : '-',
    },

    eventAlt: {
        textContent: model.tipoOcorrencia && model.tipoOcorrencia.$tag || '',
    },

    motorista: {
        textContent: model.motorista && model.motorista.$tag || '',
    },

    nomeRecebedorAlt: {
        textContent: model.nomeRecebedor || '',
    },

    placaVeiculoAlt: {
        content: model.motorista.placaVeiculo || '',
        textContent: model.motorista.placaVeiculo || '',
    },

    tipoVeiculoAlt: {
        content: model.motorista.tipoVeiculo || '',
        textContent: model.motorista.tipoVeiculo || '',
    },

    documentoRecebedorAlt: {
        content: $.filter.cpfOrCnpj(model.documentoRecebedor || ''),
        textContent: $.filter.cpfOrCnpj(model.documentoRecebedor || ''),
    },

    rgRecebedorAlt: {
        content: model.rgRecebedor || '',
        textContent: model.rgRecebedor || '',
    },

    destinatarioRazaoSocial: {
        textContent: model.destinatario && model.destinatario.$tag || '',
    },

    destinatarioCpfCnpj: {
        textContent: model.destinatario && model.destinatario.cpfCnpj ? cpfOrCnpj(model.destinatario.cpfCnpj) : '',
    },

    destinatarioUf: {
        textContent: model.destinatario && model.destinatario.endereco && model.destinatario.endereco.uf || '',
    },

    destinatarioCep: {
        textContent: model.destinatario && model.destinatario.endereco && model.destinatario.endereco.cep ?
            cep(model.destinatario.endereco.cep) : '',
    },

    embarcadorNomeFantasia: {
        textContent: model.embarcador &&
            model.embarcador.responsavel &&
            model.embarcador.responsavel.nomeFantasia || '',
    },

    embarcadorRazaoSocial: {
        textContent: model.embarcador &&
            model.embarcador.responsavel &&
            model.embarcador.responsavel.razaoSocial || '',
    },

    embarcadorCpfCnpj: {
        textContent: model.embarcador &&
        model.embarcador.responsavel &&
        model.embarcador.responsavel.cnpj ? cpfOrCnpj(model.embarcador.responsavel.cnpj) : '',
    },

    embarcadorUf: {
        textContent: model.embarcador &&
            model.embarcador.endereco &&
            model.embarcador.endereco.uf || '',
    },

    embarcadorCep: {
        textContent: model.embarcador &&
        model.embarcador.endereco &&
        model.embarcador.endereco.cep ? cep(model.embarcador.endereco.cep) : '',
    },

    transportadorRazaoSocial: {
        textContent: model.transportador && model.transportador.responsavel
            && model.transportador.responsavel.razaoSocial
            || '',
    },

    transportadorCpfCnpj: {
        textContent: model.transportador && model.transportador.responsavel && model.transportador.responsavel.cnpj ?
            cnpj(model.transportador.responsavel.cnpj) : '',
    },

    checkListAtendente: {
        textContent: model.checkListAtendimento,
    } ,

    manifesto: {
        textContent: model.cargaInfo ? model.cargaInfo.manifesto : '',
    },
})
